import { api } from "./api";

export const createProductApi = (params) => {
    return api.post(`/product/create`, JSON.stringify(params));
};

export const editProductApi = (params) => {
    return api.post(`/product/edit`, JSON.stringify(params));
};

export const listProductApi = (params) => {
    return api.get(`/product/list`, { params });
};

export const viewProductApi = (params) => {
    return api.get(`/product/view`, { params });
};

export const categoryDropdownApi = (params) => {
    return api.get(`/product/category-list`, { params });
};

export const deleteProductApi = (params) => {
    return api.delete(`/product/delete`, { params });
};

export const uploadImageApi = (params) => {
    return api.post(`/product/upload-image`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};